import React, { useState, useEffect, useRef } from 'react';

import { getEmailPreview } from '../../../actions/sessionAction';
import * as T from '../Typography';

const DEBOUNCE_MS = 500;

const DynamicEmailPreview = ({ sessionId, type, ...emailData }) => {
  const [previewHtml, setPreviewHtml] = useState('');
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const debounceTimer = useRef();

  const serializedEmailData = JSON.stringify(emailData);

  useEffect(() => {
    let ignored = false;
    clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      getEmailPreview({
        sessionId,
        type,
        ...JSON.parse(serializedEmailData)
      })
        .then(html => {
          if (ignored) return;
          setPreviewHtml(html);
          setHasLoaded(true);
          setHasError(false);
        })
        .catch(() => {
          if (!ignored) setHasError(true);
        });
    }, DEBOUNCE_MS);

    return () => {
      ignored = true;
      clearTimeout(debounceTimer.current);
    };
  }, [sessionId, type, serializedEmailData]);

  if (!hasLoaded) {
    return hasError ? (
      <T.P color="red">
        Couldn{"'"}t load the live email preview. Please try again.
      </T.P>
    ) : (
      <T.P>Loading email preview…</T.P>
    );
  }

  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: previewHtml }} />;
};

export default DynamicEmailPreview;
